import React, { Component } from 'react';
import PropTypes from 'prop-types';
import autoBind from 'react-autobind';
import classnames from 'classnames';
import { Helmet } from 'react-helmet';
import { injectIntl, FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import { show as showModal } from 'redux-modal';
import Waypoint from 'react-waypoint';
import Consent from 'ui/auth/consent';
import GeneralConsent from 'ui/auth/consent/general-consent';
import rootTemplateParts from 'ui/common/routes/root-parts';
import Loading from 'ui/common/loading';
import { socialLinkTypeIds, socialLinkTypes } from 'ui/common/social-links';
import ExternalLink from 'ui/common/external-link';
import EthereumAddressLink from 'ui/users/ethereum-address-link';
// import HighlightedSkills from 'ui/graphql/HighlightedSkills';
import UserTasks from 'ui/graphql/UserTasks/loadable';
import UserJobRoles from 'ui/graphql/UserRoles/loadable';
import MediaQuery from 'react-responsive';
import themeConfig from 'ui/theme/config';
import { push } from 'react-router-redux';
import routeTemplates from 'ui/common/routes/templates';
import { ensureScheme } from 'utils/url';
import EmsProfile from './ems-profile';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'ui/common/dropdown';
import MetaMaskModals from 'ui/components/meta-mask-modals/loadable';
import injectWeb3 from 'ui/ethereum/inject-web3';
import { messageTypes } from 'store/features/common/flash/builder';

import {
  fetchUserById,
  fetchUserByUsername,
  updateCurrentProfileSection,
} from 'store/features/users/actions';

import { fetchUserClaims } from 'store/features/claims/actions';
import {
  selectCurrentUserId,
  selectIsCurrentUserNoAccess,
  selectIsCurrentUserAdmin,
  selectCurrentUserEthereumAddress,
  selectCanCurrentUserChangeEthereumAddress,
  selectHasCurrentUserAcceptedCurrentTermsAndPrivacy,
  selectLatestAcceptedTcVersionByCurrentUser,
  selectLatestAcceptedPrivacyVersionByCurrentUser,
  selectIsCurrentUserCompanyAdmin,
} from 'store/features/auth/selectors';
import {
  selectUserByUsername,
  selectUserById,
  selectIsFetchingUserByUsername,
  selectIsFetchingUserById,
  selectIsUserFetchedAtleastOnceByUsername,
  selectIsUserFetchedAtleastOnceById,
  selectShowEducationSectionInProfileOfId,
  selectShowWorkSectionInProfileOfId,
  selectShowSkillsSectionInProfileOfId,
  selectShowBadgesSectionInProfileOfId,
} from 'store/features/users/selectors';
import {
  selectUserClaims,
  selectIsFetchingUserClaims,
  selectUserClaimsAtleastOnce,
} from 'store/features/claims/selectors';
import { selectUserWorkExperienceEntries } from 'store/features/work-experience/selectors';
import { selectUserEducationEntries } from 'store/features/education/selectors';

import WorkExperienceSection from './work-experience-section';
import EducationSection from './education-section';
import CareerTimelinesViz from './career-timelines-viz';
import SkillSection from 'ui/users/skills';
import Badges from './badges';
import RequestedForDeletion from './requested-delete';
import ModalPureText from 'ui/components/modal-pure-text/loadable';

import UpdateBasicInfo, { MODAL_NAME as UPDATE_BASIC_INFO_MODAL } from 'ui/graphql/UpdateBasicInfo';
import LogoutAllDevices, {
  MODAL_NAME as LOGOUT_ALL_DEVICES_MODAL,
} from 'ui/graphql/LogoutAllDevices';
import UpdateSocialLinks, {
  MODAL_NAME as UPDATE_SOCIAL_LINKS_MODAL,
} from 'ui/graphql/UpdateSocialLinks';
import { MODAL_NAME as SET_ETHEREUM_ADDRESS_MODAL_NAME } from 'ui/users/set-eth-address/index';
import SetEthreumAddressModal from 'ui/users/set-eth-address';
import styles from './index.module.scss';
import * as messages from './messages';
import { sidebar, defaultHeaderImages } from 'resources/page/profile';

// components from 'rebranding'
import Avatar from 'ui/users/avatar';
import Icon from 'ui/common/icon';
import { SideBarContainer, SideBarItem } from 'ui/common/side-bar';
import Evaluations from 'ui/users/evaluations';
import EventEvaluations from 'ui/users/event-evaluations';
import injectReducer from 'utils/injectReducer';
import FetchAIPSkillsReducer from 'store/graphql/FetchAipSkills/reducer';
import { compose } from 'redux';
import { selectAIPSkills } from 'store/graphql/FetchAipSkills/selectors';
import Button from 'ui/common/button';
import { selectMetaMaskStatus, METAMASK_STATUSES } from 'store/features/ethereum/selectors';
import { addMessage } from 'store/features/common/flash/actions';

// import EmsEditMyInfoEmployeeSafe from 'ui/graphql/EmsEditMyInfoEmployeeSafe/loadable';

const { request: fetchUserByIdRequest } = fetchUserById;
const { request: fetchUserByUsernameRequest } = fetchUserByUsername;
const { request: fetchUserClaimsRequest } = fetchUserClaims;

export class Details extends Component {
  static propTypes = {
    id: PropTypes.string,
    username: PropTypes.string,
    user: PropTypes.object,
    claims: PropTypes.arrayOf(PropTypes.object),
  };

  constructor(props) {
    super(props);

    autoBind(this);

    this.state = {
      isBioModalOpen: false,
      isEditInfoOpen: false,
      showMetamaskModal: false,
    };

    this.defaultHeaderIndex = Math.round(Math.random() * (defaultHeaderImages.length - 1));
  }

  componentDidMount() {
    const {
      id,
      username,
      fetchedUserAtleastOnce,
      fetchUserByUsernameRequest,
      fetchUserByIdRequest,
      fetchedClaimsAtleastOnce,
      fetchUserClaimsRequest,
    } = this.props;

    if (!fetchedUserAtleastOnce) {
      if (username) {
        fetchUserByUsernameRequest({ username: username });
      } else if (id) {
        fetchUserByIdRequest({ userId: id });
      }
    }
    if (id && !fetchedClaimsAtleastOnce) fetchUserClaimsRequest({ userId: id });
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      metamaskStatus,
      unregisterPolling, // from injectWeb3
    } = this.props;

    // stop polling for web3 information if metamask status is connected.
    if (
      metamaskStatus === METAMASK_STATUSES.connected &&
      prevProps.metamaskStatus !== METAMASK_STATUSES.connected
    ) {
      unregisterPolling();
    }

    return true;
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.id && !nextProps.fetchedClaimsAtleastOnce && this.props.id !== nextProps.id) {
      nextProps.fetchUserClaimsRequest({ userId: nextProps.id });
    }
    if (this.props.id !== nextProps.id) {
      nextProps.updateCurrentProfileSection(nextProps.id, nextProps.user ? 'bio' : '');
    }
  }

  componentWillUnmount() {
    this.props.updateCurrentProfileSection(this.props.id, '');
  }

  toggleEditInfoDropDown() {
    this.setState({
      isEditInfoOpen: !this.state.isEditInfoOpen,
    });
  }

  renderHelmet() {
    const { user, fetchingUser } = this.props;

    if (fetchingUser || !user) return null;

    const title = user.name;
    const description = user.bio;
    let image = user.imgUrl;
    if (image) ensureScheme(image);

    return (
      <Helmet>
        <title>Indorse | {title}</title>
        {description && <meta name="description" content={description} />}
        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="profile" />
        <meta property="og:title" content={title} />
        {description && <meta property="og:description" content={description} />}
        {image && <meta property="og:image" content={image} />}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content={title} />
        {description && <meta name="twitter:description" content={description} />}
        {image && <meta property="twitter:image" content={image} />}
      </Helmet>
    );
  }

  showBasicInfoModal() {
    this.props.showModal(UPDATE_BASIC_INFO_MODAL);
  }

  showSocialLinksModal() {
    this.props.showModal(UPDATE_SOCIAL_LINKS_MODAL);
  }

  showEthAddressModal() {
    this.props.showModal(SET_ETHEREUM_ADDRESS_MODAL_NAME);
  }

  showLogoutAllDevicesModal() {
    this.props.showModal(LOGOUT_ALL_DEVICES_MODAL);
  }

  showConnectToMetamask() {
    const { metamaskStatus, addMessage, registerPolling } = this.props;

    registerPolling();
    if (metamaskStatus !== METAMASK_STATUSES.connected) {
      this.setState({
        showMetamaskModal: true,
      });
    } else {
      addMessage({
        kind: messageTypes.success,
        content: 'You have successfully connected to Metamask.',
      });
    }
  }

  toggleMetamaskModal(bool) {
    this.setState({
      showMetamaskModal: bool,
    });
  }

  renderSocialLinkItem(socialLink, index) {
    if (!socialLink) return null;

    const { intl: { formatMessage } } = this.props;
    const { type, url } = socialLink;

    if (!url) return null;

    const item = socialLinkTypes[type] || socialLinkTypes[socialLinkTypeIds.website];
    return (
      <li
        key={`${index}-${socialLinkTypeIds[type]}`}
        className={classnames('pr-3 py-2 d-inline-block')}
      >
        <ExternalLink href={url} openInNewTab>
          <Icon
            name={item.iconCustomClass || item.iconFaClass}
            tooltip={formatMessage(item.messages.name)}
            background
          />
        </ExternalLink>
      </li>
    );
  }

  renderSocialLinks() {
    const { user, fetchingUser } = this.props;
    if (!user || fetchingUser) return null;

    const items =
      user.socialLinks &&
      user.socialLinks.map((item, index) => this.renderSocialLinkItem(item, index)).filter(Boolean);

    if (!items || !items.length) return null;

    return <ul className={classnames('d-inline', styles.socialLinksList)}>{items}</ul>;
  }

  renderHeader() {
    const {
      user,
      fetchingUser,
      isCurrentUser,
      updateCurrentProfileSection,
      isCurrentUserCompanyAdmin,
      isCurrentUserAdmin,
    } = this.props;

    if (fetchingUser || !user) return <Loading />;

    return (
      <div>
        <Waypoint
          topOffset={'40%'}
          bottomOffset={'40%'}
          scrollableAncestor={window}
          onEnter={() => {
            updateCurrentProfileSection(user.id, 'bio');
          }}
        >
          <div>
            <div
              className={classnames('border-bottom', styles.bgImage)}
              id="bio"
              style={{
                backgroundImage: `url('${defaultHeaderImages[this.defaultHeaderIndex]}')`,
              }}
            />
            <div className="container">
              <div className="row">
                <div className={classnames('col-12')}>
                  <div className={classnames('row justify-content-between py-5')}>
                    <div className={classnames('col-12', 'col-lg-5 col-xl-5')}>
                      <div className={classnames('row')}>
                        <div className="col-12">
                          <div className="media">
                            <div className="text-center">
                              <Avatar
                                user={user}
                                size={70}
                                className={classnames('text-center align-self-start mr-4')}
                              />
                              {user.verified ? (
                                <Icon
                                  name="icon--verified"
                                  tooltip="Verified"
                                  background
                                  className={classnames('text-center align-self-start mr-4')}
                                />
                              ) : (
                                <Icon
                                  name="icon--verified-not"
                                  tooltip="Not Verified"
                                  background
                                  className={classnames('text-center align-self-start mr-4')}
                                />
                              )}
                            </div>
                            <div className={classnames('media-body')}>
                              <h1 className={classnames('mb-2', styles.name)}>{user.name}</h1>
                              {isCurrentUserAdmin &&
                                user.validator &&
                                user.validator.badges &&
                                user.validator.badges.map(badge => {
                                  return (
                                    <img
                                      key={badge.key}
                                      className={classnames(
                                        'cursor-pointer',
                                        styles.validatorBadgeCover
                                      )}
                                      id="badge"
                                      src={`${badge.image.iconUrl}`}
                                      title={badge.description}
                                      alt={badge.name}
                                    />
                                  );
                                })}
                              {user.username && <p className="pb-1">{`@${user.username}`}</p>}
                              {isCurrentUser &&
                                user.ethereumAddress && (
                                  <MediaQuery minWidth={themeConfig.layout.gridBreakpoints.sm}>
                                    <p className={classnames('gray pb-1', styles.wordWrap)}>
                                      <EthereumAddressLink
                                        ethereumAddress={user.ethereumAddress}
                                        openInNewTab
                                      />
                                    </p>
                                  </MediaQuery>
                                )}
                              {isCurrentUser &&
                                user.ethereumAddress && (
                                  <MediaQuery maxWidth={themeConfig.layout.gridBreakpoints.sm - 1}>
                                    <p className={classnames('gray pb-1', styles.wordWrap)}>
                                      <EthereumAddressLink
                                        ethereumAddress={
                                          user.ethereumAddress.length > 21 &&
                                          user.ethereumAddress.substring(0, 21).concat('...')
                                        }
                                        openInNewTab
                                      />
                                    </p>
                                  </MediaQuery>
                                )}
                              <UpdateBasicInfo />
                              <UpdateSocialLinks />
                              <SetEthreumAddressModal />
                              <MediaQuery minWidth={themeConfig.layout.gridBreakpoints.sm}>
                                {this.renderBioBody()}
                              </MediaQuery>
                              <LogoutAllDevices />
                            </div>
                          </div>
                        </div>
                        <div className="col-12">
                          <MediaQuery maxWidth={themeConfig.layout.gridBreakpoints.sm - 1}>
                            {this.renderBioBody()}
                          </MediaQuery>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 col-lg-6 col-xl-7 pt-5 pt-lg-0">
                      {/* <HighlightedSkills userId={id} canManage={canManage} /> */}
                      {!isCurrentUserCompanyAdmin && isCurrentUser && <UserTasks />}
                      {!isCurrentUser && <UserJobRoles userId={user.id} />}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Waypoint>
      </div>
    );
  }

  renderBioBody() {
    const {
      user,
      isCurrentUser,
      canChangeEthereumAddress,
      hasEthAddress,
      push,
      intl: { formatMessage },
      metamaskStatus,
    } = this.props;

    const { isBioModalOpen, showMetamaskModal } = this.state;
    return (
      <div>
        {user.bio && (
          <p className="pt-3">
            <strong>{formatMessage(messages.labels.bio)}</strong>
          </p>
        )}
        <p className={classnames('gray pt-2 pb-3')}>
          {`${(user.bio || '').substring(0, 200)}`}
          {(user.bio || '').length > 200 && '...'}
        </p>
        {(user.bio || '').length > 200 && (
          <a className="cursor-pointer" onClick={() => this.setState({ isBioModalOpen: true })}>
            {formatMessage(messages.labels.readMore)}
          </a>
        )}
        <ModalPureText
          closeFn={() => this.setState({ isBioModalOpen: false })}
          isOpen={isBioModalOpen}
        >
          <p className="mb-5 text-break-word text-whitespace-pre-wrap text-center">{user.bio}</p>
        </ModalPureText>
        <div>{this.renderSocialLinks()}</div>

        {isCurrentUser && (
          <div className="list-inline">
            <div className="list-inline-item">
              <Dropdown
                isOpen={this.state.isEditInfoOpen}
                toggle={() => this.toggleEditInfoDropDown()}
              >
                <DropdownToggle>
                  <Button color="border-black" icon="fa fa-pencil mr-3">
                    {formatMessage(messages.labels.editInformation)}
                  </Button>
                  {/*<Icon*/}
                  {/*  name="icon--more"*/}
                  {/*  background*/}
                  {/*  className={classnames('text-center align-self-start')}*/}
                  {/*/>*/}
                  {/*<div className="list-inline-item text-muted">*/}
                  {/*  <p>{formatMessage(messages.labels.editInformation)}</p>*/}
                  {/*</div>*/}
                </DropdownToggle>
                <DropdownMenu>
                  <DropdownItem onClick={() => this.showBasicInfoModal()}>
                    {formatMessage(messages.labels.editProfile)}
                  </DropdownItem>

                  {canChangeEthereumAddress && (
                    <DropdownItem onClick={() => this.showEthAddressModal()}>
                      {formatMessage(messages.labels.editEthAddr)}
                    </DropdownItem>
                  )}

                  {!hasEthAddress && (
                    <DropdownItem onClick={() => this.showEthAddressModal()}>
                      {formatMessage(messages.labels.addEthAddr)}
                    </DropdownItem>
                  )}

                  <DropdownItem onClick={() => this.showSocialLinksModal()}>
                    {formatMessage(messages.labels.editSocialLinks)}
                  </DropdownItem>

                  <DropdownItem onClick={() => push(routeTemplates.imports.linkedInCsv)}>
                    {formatMessage(messages.labels.importLinkedIn)}
                  </DropdownItem>

                  <DropdownItem onClick={() => this.showLogoutAllDevicesModal()}>
                    {formatMessage(messages.labels.logoutAllDevices)}
                  </DropdownItem>
                  <DropdownItem onClick={() => this.showConnectToMetamask()}>
                    {formatMessage(messages.labels.connectToMetamask)}
                  </DropdownItem>
                </DropdownMenu>
              </Dropdown>
            </div>
            {showMetamaskModal &&
              METAMASK_STATUSES.connected !== metamaskStatus && (
                <MetaMaskModals
                  metamaskStatus={metamaskStatus}
                  displayType="modal"
                  onModalClose={() => this.toggleMetamaskModal(false)}
                  modalState={showMetamaskModal}
                />
              )}
          </div>
        )}
      </div>
    );
  }

  renderTimelinesViz() {
    const { fetchingUser, user, userEducation, userWorkExperience } = this.props;

    if (fetchingUser || !user) return null;

    return (
      ((userEducation && userEducation.length > 0) ||
        (userWorkExperience && userWorkExperience.length > 0)) && (
        <div className={styles.timelinesViz}>
          <div className="container">
            <div className="row justify-content-center pt-4 pb-3">
              <div className="col-12 text-center">
                <CareerTimelinesViz
                  userEducation={userEducation}
                  userWorkExperience={userWorkExperience}
                />
              </div>
            </div>
          </div>
        </div>
      )
    );
  }

  renderWorkExperienceSection() {
    const {
      id,
      showWorkSection,
      userWorkExperience,
      canManage,
      updateCurrentProfileSection,
    } = this.props;

    if (!showWorkSection) return null;
    return (
      <div className="container pt-3">
        <Waypoint
          topOffset={'40%'}
          bottomOffset={'40%'}
          scrollableAncestor={window}
          onEnter={() => {
            updateCurrentProfileSection(id, 'workExperience');
          }}
        >
          <div>
            <WorkExperienceSection canManage={canManage} entries={userWorkExperience} />
          </div>
        </Waypoint>
      </div>
    );
  }

  renderEducationSection() {
    const {
      id,
      userEducation,
      canManage,
      updateCurrentProfileSection,
      showEducationSection,
    } = this.props;

    if (!showEducationSection) return null;

    return (
      <div className="container pt-3">
        <Waypoint
          topOffset={'40%'}
          bottomOffset={'40%'}
          scrollableAncestor={window}
          onEnter={() => {
            updateCurrentProfileSection(id, 'education');
          }}
        >
          <div>
            <EducationSection canManage={canManage} entries={userEducation} />
          </div>
        </Waypoint>
      </div>
    );
  }

  renderSkillSection() {
    const { id, showSkillsSection, user, canManage, updateCurrentProfileSection } = this.props;
    if (!showSkillsSection) return null;

    return (
      <div className="container pt-3">
        <Waypoint
          topOffset={'40%'}
          bottomOffset={'40%'}
          scrollableAncestor={window}
          onEnter={() => {
            updateCurrentProfileSection(user.id, 'skills');
          }}
        >
          <div>
            <SkillSection userId={id} canManage={canManage} />
          </div>
        </Waypoint>
      </div>
    );
  }

  renderMyEvaluation() {
    const { user, canManage } = this.props;
    return (
      <div className="container">
        <Waypoint
          topOffset={'40%'}
          bottomOffset={'40%'}
          scrollableAncestor={window}
          onEnter={() => {
            updateCurrentProfileSection(user.id, 'evaluations');
          }}
        >
          <div>
            <Evaluations canManage={canManage} />
          </div>
        </Waypoint>
      </div>
    );
  }

  renderEventEvaluations() {
    const { user, canManage } = this.props;
    return (
      <div className="container">
        <Waypoint
          topOffset={'40%'}
          bottomOffset={'40%'}
          scrollableAncestor={window}
          onEnter={() => {
            updateCurrentProfileSection(user.id, 'evaluations');
          }}
        >
          <div>
            <EventEvaluations canManage={canManage} />
          </div>
        </Waypoint>
      </div>
    );
  }

  renderBadges() {
    const { id, showBadgesSection, user, updateCurrentProfileSection } = this.props;
    if (!showBadgesSection) return null;

    return (
      <div className="container py-3">
        <Waypoint
          topOffset={'40%'}
          bottomOffset={'40%'}
          scrollableAncestor={window}
          onEnter={() => {
            updateCurrentProfileSection(id, 'badges');
          }}
        >
          <div>
            <Badges member={user} userId={id} />
          </div>
        </Waypoint>
      </div>
    );
  }

  renderComingSoon() {
    const { id, fetchingUser, fetchingClaims } = this.props;

    if (!id || fetchingUser || fetchingClaims) return null;

    return (
      <div className="container-fluid pt-5 pb-4">
        <div
          className={classnames(
            'row',
            'justify-content-center',
            'align-items-center',
            styles.launch
          )}
        >
          <div className={classnames('col-12 col-md-8 text-center py-4')}>
            <p className="lead">
              <FormattedMessage
                id="users.details.under-construction"
                defaultMessage="This page is under development. We will allow users to add more details and edit their profile once we launch"
              />
            </p>
          </div>
        </div>
      </div>
    );
  }

  renderSideBar() {
    const { intl: { formatMessage } } = this.props;

    return (
      <SideBarContainer>
        {sidebar.map(item => {
          return (
            <SideBarItem key={item.id} scrollToId={item.id}>
              <span className="pr-3">{formatMessage(item.messages.title)}</span>
              <img width="15px" height="15px" src={item.image} alt={item.id} />
            </SideBarItem>
          );
        })}
      </SideBarContainer>
    );
  }

  renderOrdinaryUserInfo() {
    const { showComingSoon, isCurrentUser, isCurrentUserCompanyAdmin, isDiwaliEvent } = this.props;
    return (
      <React.Fragment>
        {!isCurrentUserCompanyAdmin && isCurrentUser && isDiwaliEvent
          ? this.renderEventEvaluations()
          : null}
        {!isCurrentUserCompanyAdmin && this.renderSkillSection()}
        {/* Evaluation is only private, no visible to public */}
        {!isCurrentUserCompanyAdmin && isCurrentUser ? this.renderMyEvaluation() : null}
        {/* {this.renderTimelinesViz()} */}
        {!isCurrentUserCompanyAdmin && this.renderWorkExperienceSection()}
        {!isCurrentUserCompanyAdmin && this.renderEducationSection()}
        {!isCurrentUserCompanyAdmin && this.renderBadges()}
        {!isCurrentUserCompanyAdmin && showComingSoon && this.renderComingSoon()}
        {!isCurrentUserCompanyAdmin && this.renderSideBar()}
      </React.Fragment>
    );
  }

  render() {
    const {
      // hasSubNavbar,
      username,
      id,
      isCurrentUser,
      currentUserAcceptedCurrentTermsAndPrivacy,
      fetchingUser,
      user,
      isEmsUser,
      isNewUser,
    } = this.props;

    if (!username && !id) return null;

    if (fetchingUser || !user) return <Loading />;
    if (isCurrentUser && !currentUserAcceptedCurrentTermsAndPrivacy) {
      if (!isNewUser) return <GeneralConsent />;
      else return <Consent />;
    }

    if (isEmsUser && isCurrentUser) return <EmsProfile user={user} />;

    return (
      <div className={classnames(styles.profile)}>
        {this.renderHelmet()}
        {isCurrentUser && <RequestedForDeletion />}
        {this.renderHeader()}
        {/* {this.renderPostionSection()} */}
        {this.renderOrdinaryUserInfo()}
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  const currentUserId = selectCurrentUserId(state);
  let usernameFromRoute =
    ownProps && ownProps.match && ownProps.match.params && ownProps.match.params.username;
  if (usernameFromRoute) usernameFromRoute = usernameFromRoute.toLowerCase();
  const username = rootTemplateParts.indexOf(usernameFromRoute) >= 0 ? null : usernameFromRoute;
  let user = username ? selectUserByUsername(state, { username }) : null;
  const id = user
    ? user.id
    : (ownProps && ownProps.match && ownProps.match.params && ownProps.match.params.id) ||
      (usernameFromRoute ? null : currentUserId);
  user = user || (id ? selectUserById(state, { id }) : null);
  const isEmsUser = user && user.type === 'EMS_USER';
  const isCurrentUser = currentUserId ? id === currentUserId : false;
  const canManage = isCurrentUser && !selectIsCurrentUserNoAccess(state);
  const showComingSoon = isCurrentUser && !canManage;
  const fetchingUser = username
    ? selectIsFetchingUserByUsername(state, { username })
    : selectIsFetchingUserById(state, { id });
  const canChangeEthereumAddress =
    isCurrentUser && selectCanCurrentUserChangeEthereumAddress(state);
  const hasEthAddress = selectCurrentUserEthereumAddress(state);
  const showWorkSection = selectShowWorkSectionInProfileOfId(state, { id });
  const showEducationSection = selectShowEducationSectionInProfileOfId(state, { id });
  const showSkillsSection = selectShowSkillsSectionInProfileOfId(state, { id });
  const showBadgesSection = selectShowBadgesSectionInProfileOfId(state, { id });
  const aipSkills = selectAIPSkills(state);
  // const hasSubNavbar =
  //   showPositionsSection ||
  //   showWorkSection ||
  //   showEducationSection ||
  //   showSkillsSection ||
  //   showBadgesSection;
  const isLatestTc =
    selectLatestAcceptedTcVersionByCurrentUser(state) === 3 ||
    !selectLatestAcceptedTcVersionByCurrentUser(state);
  const isLatestPrivacy =
    selectLatestAcceptedPrivacyVersionByCurrentUser(state) === 3 ||
    !selectLatestAcceptedPrivacyVersionByCurrentUser(state);
  const userTags = user && user.tags;
  const isDiwaliEvent = Array.isArray(userTags) && userTags.find(item => item === 'diwali');
  return {
    isDiwaliEvent,
    id,
    username,
    currentUserId,
    isCurrentUser,
    canManage,
    showComingSoon,
    fetchingUser,
    user,
    isEmsUser,
    fetchedUserAtleastOnce: username
      ? selectIsUserFetchedAtleastOnceByUsername(state, { username })
      : selectIsUserFetchedAtleastOnceById(state, { id }),
    fetchingClaims: id ? selectIsFetchingUserClaims(state, { userId: id }) : false,
    claims: id ? selectUserClaims(state, { userId: id, aipSkills }) : [],
    fetchedClaimsAtleastOnce: id ? selectUserClaimsAtleastOnce(state, { userId: id }) : false,
    userWorkExperience: id ? selectUserWorkExperienceEntries(state, { userId: id }) : [],
    userEducation: id ? selectUserEducationEntries(state, { userId: id }) : [],
    showLinkedInImportButton: !fetchingUser && user,
    isCurrentUserAdmin: selectIsCurrentUserAdmin(state),
    currentUserAcceptedCurrentTermsAndPrivacy: selectHasCurrentUserAcceptedCurrentTermsAndPrivacy(
      state
    ),
    canChangeEthereumAddress,
    hasEthAddress,
    showWorkSection,
    showEducationSection,
    showSkillsSection,
    showBadgesSection,
    isCurrentUserCompanyAdmin: selectIsCurrentUserCompanyAdmin(state),
    // hasSubNavbar,
    isNewUser: isLatestTc && isLatestPrivacy,
    metamaskStatus: selectMetaMaskStatus(state), //polling  if done in injectWeb3 and pass the status to reducer
  };
}

const mapDispatchToProps = {
  fetchUserByIdRequest,
  fetchUserByUsernameRequest,
  fetchUserClaimsRequest,
  showModal,
  updateCurrentProfileSection,
  push,
  addMessage,
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);
const withFetchAIPSkillsReducer = injectReducer({
  key: 'FetchAIPSkills',
  reducer: FetchAIPSkillsReducer,
});

export default compose(withFetchAIPSkillsReducer, withConnect)(injectIntl(injectWeb3(Details)));
